import axios from "./axios";
export const getLimits = () => axios.get('/limits/v1');